import RecordBook from "./RecordBook";

export default RecordBook;
